import React from "react";
import LogoText from "./img/inspiration-text.svg";
import "./style.scss";

export default function SideBySideLayout({
  children,
  logo = LogoText,
  bgImageMobile = "",
  bgImageDesktop = "",
  position = "top",
}) {
  const bgImageMobileVar = `url('${bgImageMobile}')`;
  const bgImageDesktopVar = `url('${bgImageDesktop}')`;

  return (
    <section
      className="side-by-side-layout"
      style={{
        "--bgImageMobile": bgImageMobileVar,
        "--bgImageDesktop": bgImageDesktopVar,
      }}
    >
      <header className={`mobile-header full-width ${position}`}></header>
      <img className="logo-text" src={logo} alt="Inspiration Club" />
      <div className="content-wrapper">{children}</div>
    </section>
  );
}
